export class RouteSegment {
  public static readonly BUDGET: string = "budget";
  public static readonly COSTS: string = "costs";
  public static readonly DECLARABILITY: string = "declarability";
  public static readonly CREATE_BUDGET_BY_FORECAST: string = 'create-budget-by-forecast';
  public static readonly PERSONNEL: string = "personnel";
  public static readonly PROGNOSIS: string = "prognosis";
  public static readonly PROJECT: string = "project";
}